import { render, staticRenderFns } from "./cambioDatos.vue?vue&type=template&id=1a6159d8&"
import script from "./cambioDatos.vue?vue&type=script&lang=js&"
export * from "./cambioDatos.vue?vue&type=script&lang=js&"
import style0 from "./cambioDatos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports